exports.performance = window.performance;
